import React from 'react';
import { LeftMenuItemProps } from 'types/mainPage';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

export const LeftMenuItem: React.FC<LeftMenuItemProps> = ({
  handleMenuItem,
  text,
}): JSX.Element => {
  return (
    <ListItemButton
      onClick={() => {
        handleMenuItem();
      }}
    >
      <ListItemText primary={text} />
    </ListItemButton>
  );
};
